import { render, staticRenderFns } from "./CustomerContractV2RateButton.vue?vue&type=template&id=6456dc7e"
import script from "./CustomerContractV2RateButton.vue?vue&type=script&lang=js"
export * from "./CustomerContractV2RateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports